export enum JourneySurveyQuestionType {
    SingleSelect = 'SingleSelect',
    MultiSelect = 'MultiSelect',
    Text = 'Text'
}
